<footer>
  <div class="ama-footer">
    <div class="ama-footer__main">
      <div class="ama-footer__main__inner freida-v2  layout-container">
        <div class="ama-footer__main__logo-area">
          <a class="ama-footer__main__ama-logo" title="AMA Logo" href="https://www.ama-assn.org/">
            <img
              src="assets/ama-logo-white.svg"
              alt="American Medical Association"
              width="103"
              height="44"
              class="ama-footer__main__ama-logo--img"
            />
          </a>
          <p class="ama-footer__main__mission">{{ model.content.mission }}</p>
        </div>
        @for (category of categories; track $index) {
          <div class="ama-footer__main__section">
            <h2 class="header">{{ category.title }}</h2>
            <ul>
              @for (link of category.links; track $index) {
                <li>
                  @if (isExternal(link.url)) {
                    <a
                      [href]="link.url"
                      [target]="link.target || ''"
                      [rel]="link.rel || ''"
                      [attr.aria-label]="link.ariaLabel"
                      >{{ link.title }}</a
                    >
                  } @else {
                    <a
                      [href]="link.url"
                      (click)="navigateTo(link.url, $event)"
                      [target]="link.target || ''"
                      [rel]="link.rel || ''"
                      [attr.aria-label]="link.ariaLabel"
                      >{{ link.title }}</a
                    >
                  }
                </li>
              }
            </ul>
          </div>

          <div class="ama-footer__mobile__accordion">
            <details class="ama-footer__mobile__details">
              <summary class="ama-footer__mobile__summary">{{ category.title }}</summary>
              <ul>
                @for (link of category.links; track $index) {
                  <li>
                    @if (isExternal(link.url)) {
                      <a
                        [href]="link.url"
                        [target]="link.target || ''"
                        [rel]="link.rel || ''"
                        [attr.aria-label]="link.ariaLabel"
                        >{{ link.title }}</a
                      >
                    } @else {
                      <a
                        [href]="link.url"
                        (click)="navigateTo(link.url, $event)"
                        [target]="link.target || ''"
                        [rel]="link.rel || ''"
                        [attr.aria-label]="link.ariaLabel"
                        >{{ link.title }}</a
                      >
                    }
                  </li>
                }
              </ul>
            </details>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="ama-footer__sub freida-v2  layout-container">
    <div class="ama-footer__sub__inner">
      <div class="ama-footer__sub__utility">
        <ul class="ama-footer__sub__utility__links">
          @for (link of utility; track $index) {
            <li>
              @if (isExternal(link.url)) {
                <a
                  [href]="link.url"
                  [target]="link.target || ''"
                  [rel]="link.rel || ''"
                  [attr.aria-label]="link.ariaLabel"
                  >{{ link.label }}</a
                >
              } @else {
                <a
                  [href]="link.url"
                  (click)="navigateTo(link.url, $event)"
                  [target]="link.target || ''"
                  [rel]="link.rel || ''"
                  [attr.aria-label]="link.ariaLabel"
                  >{{ link.label }}</a
                >
              }
            </li>
          }
        </ul>
        <div class="ama-footer__sub__copyright">
          <p>{{ copyright }}</p>
        </div>
      </div>

      <div class="ama-footer__sub__social">
        <p>Follow Us</p>
        <div class="ama-footer__sub__social__links">
          @for (link of social; track $index) {
            <a
              [href]="link.url"
              [target]="link.target || ''"
              [rel]="link.rel || ''"
              [attr.aria-label]="link.ariaLabel"
              >
              <i class="{{ 'ph-fill ' + link.icon }}" size="1.25em"></i>
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</footer>
